// extracted by mini-css-extract-plugin
export default {"shapka":"BfQOfndl","shapkaAdditional":"Ezel77ef","shapkaSearch":"Z1qsxV9A","desktop":"desktop"};